module.exports = __webpack_public_path__ + "img/hotelLogo-04.a68a3837.png";